export default __webpack_public_path__ + "static/media/advertising_img.d9a49844.jpeg";